(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7a3e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7a3e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gUptJ", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $c4f5a3cd4f9df57b$export$6503ec6e8aabbaf; }, function (v) { return $c4f5a3cd4f9df57b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $c4f5a3cd4f9df57b$export$f7ad0328861e2f03; }, function (v) { return $c4f5a3cd4f9df57b$export$f7ad0328861e2f03 = v; });
var $c4f5a3cd4f9df57b$export$6503ec6e8aabbaf;
var $c4f5a3cd4f9df57b$export$f7ad0328861e2f03;
"use strict";
var $c4f5a3cd4f9df57b$var$mapping = new Map();
function $c4f5a3cd4f9df57b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c4f5a3cd4f9df57b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c4f5a3cd4f9df57b$var$resolve(id) {
    var resolved = $c4f5a3cd4f9df57b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c4f5a3cd4f9df57b$export$6503ec6e8aabbaf = $c4f5a3cd4f9df57b$var$register;
$c4f5a3cd4f9df57b$export$f7ad0328861e2f03 = $c4f5a3cd4f9df57b$var$resolve;

});

parcelRegister("jHGl0", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $e582dfdf0dcb53aa$export$bdfd709ae4826697; }, function (v) { return $e582dfdf0dcb53aa$export$bdfd709ae4826697 = v; });
var $e582dfdf0dcb53aa$export$bdfd709ae4826697;
var $e582dfdf0dcb53aa$export$c9e73fbda7da57b6;
var $e582dfdf0dcb53aa$export$5a759dc7a1cfb72a;
"use strict";
var $e582dfdf0dcb53aa$var$bundleURL = {};
function $e582dfdf0dcb53aa$var$getBundleURLCached(id) {
    var value = $e582dfdf0dcb53aa$var$bundleURL[id];
    if (!value) {
        value = $e582dfdf0dcb53aa$var$getBundleURL();
        $e582dfdf0dcb53aa$var$bundleURL[id] = value;
    }
    return value;
}
function $e582dfdf0dcb53aa$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $e582dfdf0dcb53aa$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $e582dfdf0dcb53aa$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $e582dfdf0dcb53aa$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$e582dfdf0dcb53aa$export$bdfd709ae4826697 = $e582dfdf0dcb53aa$var$getBundleURLCached;
$e582dfdf0dcb53aa$export$c9e73fbda7da57b6 = $e582dfdf0dcb53aa$var$getBaseURL;
$e582dfdf0dcb53aa$export$5a759dc7a1cfb72a = $e582dfdf0dcb53aa$var$getOrigin;

});

var $cbc42eba7decbb34$exports = {};


(parcelRequire("gUptJ")).register((parcelRequire("jHGl0")).getBundleURL("bs1yQ"), JSON.parse('["bs1yQ","index.9a11a753.js","4EkDN","Grocery.ee978a68.js"]'));

})();
//# sourceMappingURL=index.runtime.f3dde0fd.js.map
